export const toEventModel = (form) => {
  // Extract basic fields
  const tournamentName = form.tournamentId?.tournamentName || form.tournamentId?.name || '';
  const homeTeamName = form.homeTeamId?.teamName || '';
  const awayTeamName = form.awayTeamId?.teamName || '';

  // Format date as ISO string
  const startTimeISO = form.startTime instanceof Date
    ? form.startTime.toISOString()
    : new Date(form.startTime).toISOString();

  const endTimeISO = form.endTime instanceof Date
    ? form.endTime.toISOString()
    : new Date(form.endTime).toISOString();

  // Extract createTriggers boolean value
  const createTriggersValue = typeof form.createTriggers === 'object'
    ? form.createTriggers.value
    : !!form.createTriggers;

  // Use the provided event name or generate one if not provided
  const eventName = form.eventName || [
    homeTeamName,
    homeTeamName && awayTeamName ? 'vs' : '',
    awayTeamName,
    (homeTeamName || awayTeamName) && tournamentName ? '-' : '',
    tournamentName
  ].filter(Boolean).join(' ').trim();

  // Create base event model
  const eventModel = {
    jurisdictionId: form.jurisdiction.id,
    sportType: form.sportType.id,
    startTime: startTimeISO,
    endTime: endTimeISO,
    createTriggers: createTriggersValue,
    tournamentId: form.tournamentId.id,
    name: eventName
  };

  // Add team IDs if they exist
  if (form.homeTeamId?.id) eventModel.homeTeamId = form.homeTeamId.id;
  if (form.awayTeamId?.id) eventModel.awayTeamId = form.awayTeamId.id;

  return eventModel;
}
